import {Component} from '@packages/systems/wfdl';

/**
 * The value used for both `StyleVariant` type display name and default prop label
 * when creating a new style variant property.
 */
export const DEFAULT_STYLE_VARIANT_LABEL = 'Variant';

/**
 * Represents the default `id` and `displayName` for a Base component style variant.
 */
export const BASE_VARIANT_DEFAULTS: Component.StyleVariant = {
  id: 'base',
  displayName: 'Base',
} as const;
